import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

import { Row } from '@simplywallst/ui-core';

export const Wrapper = styled(Row)`
  background: white;
  padding: ${({ theme }) => theme.x2spacePx}px;
  border-top: 1px solid #e8e8e8;
  ${media.mdDown`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;

    > button {
      display: flex;
      flex: 1;
      justify-content: center;
      align-items: center;
      &:first-child + button {
        margin-left: ${({ theme }) => theme.x1spacePx}px;
      }
    }
  `}
`;
